import React from 'react';

import { useIntl } from 'react-intl';

import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { queryClient } from 'src/lib/react-query';
import { toast } from 'src/hooks/useToast';
import { Payment } from 'src/features/payments/utils/types';
import { useUpdatePayment } from 'src/features/payments/api/useUpdatePayment';
import { LIST_PAYMENTS_RESOURCE } from 'src/features/payments/api/useListPayments';
import { PAYMENT_RESOURCE } from '../../api/useGetPayment';
import { paymentsMessages } from 'src/features/payments/utils/messages';
import PaymentFormModal from 'src/features/payments/components/forms/PaymentFormModal';

interface UpdatePaymentFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    selectedPayment: Payment;
    children?: React.ReactNode;
}

function UpdatePaymentFormModal<TData>({
    className,
    semantics,
    children,
    selectedPayment,
}: UpdatePaymentFormModalProps<TData>) {
    const { formatMessage } = useIntl();

    const { mutate, isPending } = useUpdatePayment({
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: [LIST_PAYMENTS_RESOURCE] });
            void queryClient.invalidateQueries({ queryKey: [PAYMENT_RESOURCE] });
            toast({
                title: formatMessage(paymentsMessages.updatePaymentSuccess),
                description: formatMessage(paymentsMessages.updatePaymentSuccessDescription),
            });
        },
    });

    return (
        <PaymentFormModal
            selectedPayment={selectedPayment}
            className={className}
            mutate={(values, onSuccess, onError) =>
                mutate({ ...values, paymentId: selectedPayment.id }, { onSuccess, onError })
            }
            title={formatMessage(generalMessages.editEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.EDIT}
            isPending={isPending}
            subtitle={formatMessage(paymentsMessages.editPaymentSubtitle)}
        >
            {children}
        </PaymentFormModal>
    );
}

export default UpdatePaymentFormModal;
